<template>
  <div class="overlay" v-if="!isLogin">
    <div class="overlay-backdrop"></div>
    <div class="overlay-text">
      <p>Khách hàng vui lòng<br />
      đăng ký hoặc đăng nhập<br />
      trước khi đặt vé</p>
      <div class="overlay-buttons">
        <div>
          <ion-button fill="outline" @click="showLogin" expand="block" color="secondary">Đăng ký</ion-button>
        </div>
        <div>
          <ion-button fill="outline" @click="showLogin" expand="block" color="primary">Đăng nhập</ion-button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1000;
}

.overlay-buttons {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.overlay-buttons > div {
  flex-grow: 1;
}

.overlay-backdrop {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: #000;
  opacity: 0.6;
  z-index: 1001;
}

.overlay-text {
  padding: 10px;
  position: absolute;
  left: 50%;
  top: 50%;
  width: 260px;
  background-color: #fff;
  transform: translateX(-50%) translateY(-50%);
  z-index: 1002;
  text-align: center;
  border-radius: 20px;
}
</style>

<script>
import { defineComponent } from "vue";
import authService from "@/services/auth";
import { debounce } from 'lodash';
import { useRoute, useRouter } from "vue-router";

import {
  IonButton,
} from "@ionic/vue"

export default defineComponent({
  components: {
    IonButton
  },
  computed: {
    isLogin() {
      return authService.user() && !authService.user().isAnonymous;
    },
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    return {
      showLogin: debounce(function(){
        // authService.showLogin();
        router.replace('/auth/login?from='+route.path);
      }, 1000, {leading: true, maxWait: 0}),
    }
  },
});
</script>
